export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_q01_b.eb810e16.png";